import axiosInstance from "./api_helper";

const inventoryService = {
    findAll: async () => {
        return await axiosInstance.get('/api/inventories');
    },
    fetchInventory: async (id) => {
        return await axiosInstance.get(`/api/inventories/${id}`);
    },
    closeInventory: async (id) => {
        return await axiosInstance.post(`/api/inventories/${id}/close`);
    },
    saveInventory: async (inventory) => {
        return await axiosInstance.put(`/api/inventories`, JSON.stringify(inventory));
    },


    addInventory: async (inventory) => {
        return await axiosInstance.post(`/api/inventories`, JSON.stringify(inventory));
    },
    createOrUpdateInventory: async (item, data) => {
        return await axiosInstance.post(`/api/inventories/addOrUpdate`, JSON.stringify({ inventoryDTO: data, inventoryItemDTO: item }));
    },
    updateInventory: async (payload) => {
        return await axiosInstance.put(`/api/inventories/${payload.id}`, JSON.stringify(payload.data));
    },
    deleteInventoryItem: async (id) => {
        return await axiosInstance.delete(`/api/inventories/${id}`);
    }
};
export default inventoryService;
